export default object => ({
  id: object.id,
  reference: object.reference,
  endDate: object.endDate,
  actionToDelete: object.actionToDelete,
});
